(() => {
  if (customElements.get('vyle-review-summary')) return;
  customElements.define('vyle-review-summary', class extends HTMLElement {
    connectedCallback() {
      this._abort?.abort(); this._abort = new AbortController();
      const options = { signal:this._abort.signal };
      this._update = () => {
        const reviews = document.querySelector('[data-vyle-imported-reviews]');
        const count = Number(reviews?.dataset.reviewCount), total = Number(reviews?.dataset.reviewTotal);
        if (!reviews || !Number.isInteger(count) || count < 1 || !Number.isFinite(total) || total < count || total > count * 5) { this.hidden = true; return; }
        const average = total / count, preview = reviews.dataset.reviewPreview === 'true';
        const link = this.querySelector('[data-review-link]');
        link.setAttribute('href', '#' + reviews.id);
        link.setAttribute('aria-label', 'Read ' + count + ' customer reviews');
        this.querySelector('[data-review-copy]').textContent = (preview ? 'Preview · ' : '') + average.toFixed(1) + '/5 · ' + count + ' customer reviews';
        this.querySelector('.vyle-imported-stars').style.setProperty('--rating-width', (average * 20) + '%');
        this.hidden = false;
      };
      document.addEventListener('DOMContentLoaded', this._update, options);
      document.addEventListener('shopify:section:load', this._update, options);
      document.addEventListener('shopify:section:unload', this._update, options);
      this._update();
    }
    disconnectedCallback() { this._abort?.abort(); }
  });
})();

